<template>
  <div class="commentAnshor" :linkto="comment.commentID">
  </div>

</template>

<script lang="ts">


  import {Component, Prop, Vue} from 'vue-property-decorator';
  import {CommentEvent} from '@/store/comment/commentModel';

  @Component({
    name: 'CommentAnchor',
    components: {},
  })
  export default class CommentAnchor extends Vue {

    @Prop()
    private comment!: CommentEvent;

  }
</script>
